export const primaryColor = '#C3073F';
export const primaryDarkColor = '#1A1A1D';

// Variant colors
export const successColor = '#0197F6';
export const infoColor = '#01F97F6';
export const errorColor = '#F2AF29';
export const warningColor = '#F2AF29';
